import { useContext } from "react";
import { SellerContext } from "../contexts/SellerContext";

export function useSeller() {
    const value = useContext(SellerContext);
    return value;
}